import styled from '@emotion/styled'

import { spacing } from 'main/ui'

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;

  > :not(:last-child) {
    margin-right: ${spacing.majorScale(3)}px;
  }
`
